// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AK851L {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--spacing-3);
  text-align: left;
  width: 100%;
}

.vuahkU {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-1);
}

.kL_qJo {
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.rvzYSP {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-dark);
}

.G9VjYz {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-1-5);
  margin-top: var(--spacing-2);
  width: 100%;
}

.CxspiS {
  flex: 1;
  min-width: 0;
  height: 40px;
  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);
  border-radius: var(--button-border-radius, 4px);
  font-family: var(--font-family-base);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-md);
}

.oFw5BV {
  background: var(--brand-tr-orange, #d64000);
  border: 2px solid var(--brand-tr-orange, #d64000);
  color: var(--text-neutral-white, #ffffff);
}

.oFw5BV:hover {
  background: var(--brand-tr-orange-dark, #b33600);
  border-color: var(--brand-tr-orange-dark, #b33600);
}

.bnrfoy {
  background: var(--surface-neutral-white, #ffffff);
  border: 2px solid var(--brand-tr-orange, #d64000);
  color: var(--brand-tr-orange, #d64000);
}

.bnrfoy:hover {
  background: var(--surface-neutral-pale, #f5f5f5);
}

.tF7HtK {
  font-family: var(--font-family-base);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-neutral-dark);
}

.SkuYXi {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  padding: var(--spacing-3);
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/SlowRequestFeedback/SlowRequestFeedback.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,uDAAuD;EACvD,+CAA+C;EAC/C,oCAAoC;EACpC,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,2CAA2C;EAC3C,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;EACE,gDAAgD;EAChD,kDAAkD;AACpD;;AAEA;EACE,iDAAiD;EACjD,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":[".modalContent {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: var(--spacing-3);\n  text-align: left;\n  width: 100%;\n}\n\n.text {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-1);\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.description {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-dark);\n}\n\n.actions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--spacing-1-5);\n  margin-top: var(--spacing-2);\n  width: 100%;\n}\n\n.button {\n  flex: 1;\n  min-width: 0;\n  height: 40px;\n  padding: var(--spacing-1, 8px) var(--spacing-1-5, 12px);\n  border-radius: var(--button-border-radius, 4px);\n  font-family: var(--font-family-base);\n  font-weight: var(--font-weight-semibold);\n  font-size: var(--font-size-md);\n}\n\n.primaryButton {\n  background: var(--brand-tr-orange, #d64000);\n  border: 2px solid var(--brand-tr-orange, #d64000);\n  color: var(--text-neutral-white, #ffffff);\n}\n\n.primaryButton:hover {\n  background: var(--brand-tr-orange-dark, #b33600);\n  border-color: var(--brand-tr-orange-dark, #b33600);\n}\n\n.secondaryButton {\n  background: var(--surface-neutral-white, #ffffff);\n  border: 2px solid var(--brand-tr-orange, #d64000);\n  color: var(--brand-tr-orange, #d64000);\n}\n\n.secondaryButton:hover {\n  background: var(--surface-neutral-pale, #f5f5f5);\n}\n\n.message {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-neutral-dark);\n}\n\n.slow {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-2);\n  padding: var(--spacing-3);\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContent": `AK851L`,
	"text": `vuahkU`,
	"title": `kL_qJo`,
	"description": `rvzYSP`,
	"actions": `G9VjYz`,
	"button": `CxspiS`,
	"primaryButton": `oFw5BV`,
	"secondaryButton": `bnrfoy`,
	"message": `tF7HtK`,
	"slow": `SkuYXi`
};
module.exports = ___CSS_LOADER_EXPORT___;
